import App from 'app/app.js';

function ColorService() {
  const colors = ['darkblue', 'blue', 'pink', 'purple', 'green'];

  this.getColor = function (idx) {
    return colors[(!!idx && idx >= 0 ? idx : 0) % colors.length];
  };
}

App.service('ColorService', [ColorService]);
